
import CONSTANTES from "../constantes";
import {takeEvery, call,put} from 'redux-saga/effects'



//Los siguientes sagas  son escenciales para configurar youMagazine//
//Saga getAllRevistas: esta funcion funciona para obtener todos los nombres de revistas 
//existentes en nuestro sistema, se utiliza para validaciones en el nombre de la revista
const getPermisos = () => fetch(`${CONSTANTES.URL_API}/panel/permisos/`,
  {
    method: 'GET',
    headers: new Headers({
        'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {
    console.log(e)
  })


function* sagaGetConfigs() {
    try {    
      let permisos = yield call(getPermisos);
      yield put({ type: CONSTANTES.PUT_CONFIG,permisos})
    } catch (error) 
    {
            console.log(error)
    }
}

export default function* SagasConfig() {
    yield takeEvery(CONSTANTES.GET_CONFIG, sagaGetConfigs)

}